import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=b0c2ec0e&scoped=true"
import script from "./goodsList.vue?vue&type=script&lang=js"
export * from "./goodsList.vue?vue&type=script&lang=js"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=b0c2ec0e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c2ec0e",
  null
  
)

export default component.exports